import React from "react";
import type { VocabulariesBody } from "../shared/types";
import { InlineText } from "../components/InlineText";
import { COPY } from "../copy";

/** Vocabularies (design §1.6): each closed option, its values with what they mean, and where it is used — live `GET /v1/vocab`. */
export const VocabulariesPage = ({ body }: { body: VocabulariesBody }) => (
  <div>
    {body.vocabs.map((vocab) => (
      <section key={vocab.name}>
        <h2 id={vocab.anchor} className="mt-12 scroll-mt-24 text-head4 font-semibold text-foreground">
          <code>{vocab.name}</code>
        </h2>
        <p className="mt-2 text-bodyMedium">
          <InlineText text={vocab.description} />
        </p>
        <div className="my-4 overflow-x-auto">
          <table className="w-full text-left text-bodySmall">
            <thead>
              <tr className="border-b border-border">
                <th className="px-3 py-2">{COPY.value}</th>
                <th className="px-3 py-2">{COPY.description}</th>
                <th className="px-3 py-2">{COPY.chooseWhen}</th>
              </tr>
            </thead>
            <tbody>
              {vocab.values.map((v) => (
                <tr key={v.value} className="border-b border-border align-top">
                  <td className="px-3 py-2">
                    <code>{v.value}</code>
                    {v.title ? <span className="block text-muted-foreground">{v.title}</span> : null}
                  </td>
                  <td className="px-3 py-2">{v.description ? <InlineText text={v.description} /> : null}</td>
                  <td className="px-3 py-2 text-muted-foreground">{v.chooseWhen ? <InlineText text={v.chooseWhen} /> : null}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {vocab.usedIn.length ? (
          <p className="text-bodySmall text-muted-foreground">
            <span className="font-semibold">{COPY.usedIn}: </span>
            {vocab.usedIn.map((u) => `${u.where} · ${u.field}`).join("; ")}
          </p>
        ) : null}
      </section>
    ))}
  </div>
);
